import React, { useEffect, useState } from 'react';
import LoadingSpinner from '../../../../components/common/LoadingSpinner';
import { getStorageUnitsByCompanyId } from '../../../../crud/management_api/storage_units';
import Table from './components/Table/Table';
import { StorageUnit } from './types';
import { MPPageTitle } from '../../../../components/ui';

const StorageUnits: React.FC = () => {
  const [units, setUnits] = useState<StorageUnit[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const user = JSON.parse(localStorage.getItem('user') ?? '{}');
    const companyId = user ? Number(user.company_id) : 0;
    getStorageUnitsByCompanyId(companyId)
      .then((res) => {
        setUnits(res.data);
      })
      .catch((error) => {
        console.error('Error fetching storage units: ', error);
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return <LoadingSpinner text="Cargando unidades de almacenamiento..." transparent={true} />;
  }

  return (
    <div className="flex flex-col gap-4 p-3 pb-6 lg:gap-5 lg:p-4 lg:pb-8">
      <MPPageTitle>Almacenamiento</MPPageTitle>
      <Table data={units} setData={setUnits} />
    </div>
  );
};

export default StorageUnits;
